export default __webpack_public_path__ + "static/media/640x300_03.81f479b0.jpg";